import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateChangeProposalPaymentScheduleInput,
  UpdateChangeProposalPaymentScheduleMutation,
} from '@/gql/graphql';

const UPDATE_CHANGE_PROPOSAL_PAYMENT_SCHEDULE = graphql(`
  mutation UpdateChangeProposalPaymentSchedule(
    $input: UpdateChangeProposalPaymentScheduleInput!
  ) {
    updateChangeProposalPaymentSchedule(input: $input) {
      id
      paymentSchedule {
        stages {
          stage {
            ...PaymentScheduleStageFields
          }
          stageValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoiceValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoiceProjectPercentage
        }
        explainer
        isInSync
      }
    }
  }
`);

const useUpdateChangeProposalPaymentSchedule = (
  options?: UseMutationOptions<
    UpdateChangeProposalPaymentScheduleMutation,
    unknown,
    UpdateChangeProposalPaymentScheduleInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_CHANGE_PROPOSAL_PAYMENT_SCHEDULE, {
        input,
      });
    },
    ...options,
  });
};

export default useUpdateChangeProposalPaymentSchedule;
